/**
* Dual Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Dual Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {

    className: 'dual-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const leftSplide = new Splide( '.dual-marquee-splide-left', {
        type: 'loop',
        autoScroll: {
          speed: 1,
          pauseOnHover: false,
        },
        arrows: false,
        autoWidth: true,
        gap: '32px',
        drag: false,
        pagination: false,
        direction: 'ltr', // Scroll left to right
      } ).mount( {AutoScroll} );

      // Initialize right Splide instance
      const rightSplide = new Splide( '.dual-marquee-splide-right', {
        type: 'loop',
        autoScroll: {
          speed: 1,
          pauseOnHover: false,
        },
        arrows: false,
        autoWidth: true,
        gap: '32px',
        drag: false,
        pagination: false,
        direction: 'rtl', // Scroll right to left
      } ).mount( {AutoScroll} );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'dual-marquee', COMPONENT );
} )( app );
